import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  subAccounts: {},
  subEmailsAnduserIds: [],
};

const handleChangeSubAccountStatus = (state, { data: { subUserIds }, status }) => {
  let newSubAccounts = { ...state.subAccounts };
  let { data } = newSubAccounts;
  data = data.map(item => {
    if (subUserIds.includes(item.subUserId)) return { ...item, isSubUserEnabled: status };
    return item;
  });
  newSubAccounts = { ...newSubAccounts, data };
  return { ...state, subAccounts: { ...newSubAccounts } };
};

const handleChangeSubAccount2FAStatus = (state, { data: { subUserId, subType } }) => {
  let newSubAccounts = { ...state.subAccounts };
  let { data } = newSubAccounts;
  data = data.map(item => {
    if (subUserId === item.subUserId && subType.toLowerCase() === 'sms') {
      return { ...item, mobile: '-' };
    }
    if (subUserId === item.subUserId && subType.toLowerCase() === 'google') {
      return { ...item, isUserGoogle: false };
    }
    return item;
  });
  newSubAccounts = { ...newSubAccounts, data };
  return { ...state, subAccounts: { ...newSubAccounts } };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_SUB_ACCOUNT_SUCCESS:
      return { ...state, subAccounts: action.data };
    case actionTypes.FETCH_USER_SUB_EMAIL_SUCCESS:
      return { ...state, subEmailsAnduserIds: action.data };
    case actionTypes.UPDATE_SUB_ACCOUNT_STATUS_SUCCESS:
      return handleChangeSubAccountStatus(state, action);
    case actionTypes.RESET_SUB_USER_2FA_SUCCESS:
      return handleChangeSubAccount2FAStatus(state, action);
    default:
      return state;
  }
};
